import { SystemPasswordComponent } from './../system-profile-manager/system-profile-V2/system-password/system-password.component';
import { DialogDetailedLogsComponent } from './../logs/loggingComponent/dialog-detailedLogs/dialog.detailedLogs.component';
import { LogsComponent } from './../logs/logs.component';
import { DialogSearchComponent } from './../shared/Dialogs/dialog-search/dialog.search.component';
import { UserEditComponent } from './../admin/user.editing/user.edit.component';
import { MarketLocationEditComponent } from 'src/admin-market-location/market_location.editing/market_location.edit.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
'@angular-material-components/datetime-picker';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component'
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginpageComponent } from '../loginpage/loginpage.component';
import { HomepageComponent } from '../homepage/homepage.component';
import { FolderManagerComponent } from '../folder-manager/folder-manager.component';
import { TreeviewSystemsComponent } from '../treeview-systems/treeview-systems.component';
import { AppRoutingModule } from '../app-routing/app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NavbarComponent } from '../navbar/navbar.component';
import { SystemProfileManagerComponent } from '../system-profile-manager/system-profile-manager.component';
import { SqlDataTableComponent } from '../sql-data-table/sql-data-table.component';
import { TableModule } from 'ngx-easy-table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TemplateManagerComponent } from '../template-manager/template-manager.component';
import { DateTimePickerModule } from 'ngx-datetime-picker';
import { FileUploadModule } from "ng2-file-upload";
import { SoftwareUpgradeComponent } from '../software-upgrade/software-upgrade.component';
import { PhonebookManagerComponent } from '../phonebook-manager/phonebook-manager.component';
import { TreeviewModule } from 'ngx-treeview';
import { SplitPipe } from './split.pipe';
import { AuthInterceptorService } from './services/auth-interceptor';
import { AdminController } from 'src/admin/users.component';
import { AdminMarketLocationController } from 'src/admin-market-location/market_location.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LoggingComponent } from 'src/logs/loggingComponent/logging.component';
import { ErrorComponent } from 'src/shared/404/404.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SystemProfileV2Component } from 'src/system-profile-manager/system-profile-V2/system-profile-V2.component';
import { SystemSettingComponent } from 'src/system-profile-manager/system-profile-V2/system-setting/system-setting.component';
import { SystemStateProvisioningComponent } from 'src/system-profile-manager/system-profile-V2/system-state-and-provisioing/system-state-provisioing.component';
import { InsertUnitsComponent } from 'src/system-profile-manager/dialog-insert-system/insert.systems.component';
import { AddNoteComponent } from 'src/system-profile-manager/system-profile-V2/system-state-and-provisioing/dialog-add-note/addNote.dialog.component';
import { SystemUpdateComponent } from 'src/system-profile-manager/system-profile-V2/system-update/update.system.component';
import { RollbackComponent } from 'src/system-profile-manager/system-profile-V2/system-state-and-provisioing/dialog-rollback/rollback.component';
import { AddedUnitsGraphComponent } from 'src/homepage/added-units-graph/added-units-graph.component';
import { QuickActionsComponent } from 'src/homepage/quick-actions/quick-actions.component';
import { ChartsModule } from 'ng2-charts';
import { ProvisionUnitsGraphComponent } from 'src/homepage/provision-units-graph/provision-units-graph.component';
import { MonitorUnitsGraphComponent } from 'src/homepage/monitor-units-graph/monitor-units-graph.component';
import { StatusUnitsGraphComponent } from 'src/homepage/status-units-graph/status-units-graph.component';
import { DialogMonitorProvisionComponent } from 'src/homepage/quick-actions/dialog-monitor-provision/dialog-monitor-provision.component';
import { FolderSystemsComponent } from 'src/system-profile-manager/system-profile-V2/folder-systems/folder-systems.component';
import { DialogStatusComponent } from 'src/homepage/quick-actions/dialog-status.component/dialog-status.component';
import { BulkActionsDialogComponent } from 'src/shared/Dialogs/bulk-actions/dialog.bulkActions.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReportIssueDialogComponent } from 'src/shared/Dialogs/report-issue/dialog.reportIssue.component';
import { WallpaperUploadDialogComponent } from 'src/shared/Dialogs/wallpaper-upload/dialog.wallpaperUpload.component';
import { ResetPasswordDialogComponent } from 'src/shared/Dialogs/reset-password/dialog.resetPassword.component';
import { StateDialogDetailedLogsComponent } from 'src/logs/loggingComponent/dialog-state/statedialog.detailedLogs.component';
import { DialogDetailedLogsTemplatesComponent } from 'src/logs/loggingComponent/dialog-detailedLogsTemplates/dialog.detailedTemplateLogs.component';

import { ReportGeneratorComponent } from 'src/report-generator/report-generator.component';
import { DialogReportGeneratorComponent } from 'src/shared/Dialogs/dialog-report-generator/dialog.report-generator.component';

import { DialogDetailedLogsWallpaperComponent } from 'src/logs/loggingComponent/dialog-detailedLogs_wallpaper/dialog.detailedLogs_wallpaper.component';
import { LmListsComponent } from 'src/shared/Dialogs/lm-lists/lm-lists.component';
import { CommonModule } from '@angular/common';
import { LoginpageSSOComponent } from 'src/loginpageSSO/loginpagesso.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginpageComponent,
    HomepageComponent,
    NavbarComponent,
    TreeviewSystemsComponent,
    FolderManagerComponent,
    SystemProfileManagerComponent,
    SqlDataTableComponent,
    TemplateManagerComponent,
    FileUploaderComponent,
    SoftwareUpgradeComponent,
    PhonebookManagerComponent,
    SplitPipe,
    AdminController,
    AdminMarketLocationController,
    UserEditComponent,
    MarketLocationEditComponent,
    DialogSearchComponent,
    LoggingComponent,
    LogsComponent,
    ErrorComponent,
    DialogDetailedLogsComponent,
    DialogDetailedLogsTemplatesComponent,
    SystemProfileV2Component,
    SystemSettingComponent,
    SystemPasswordComponent,
    SystemStateProvisioningComponent,
    InsertUnitsComponent,
    AddNoteComponent,
    SystemUpdateComponent,
    RollbackComponent,
    AddedUnitsGraphComponent,
    ProvisionUnitsGraphComponent,
    MonitorUnitsGraphComponent,
    QuickActionsComponent,
    StatusUnitsGraphComponent,
    DialogMonitorProvisionComponent,
    FolderSystemsComponent,
    DialogStatusComponent,
    BulkActionsDialogComponent,
    ReportIssueDialogComponent,
    WallpaperUploadDialogComponent,
    ResetPasswordDialogComponent,
    StateDialogDetailedLogsComponent,
    LoginpageSSOComponent,

    ReportGeneratorComponent,
    DialogReportGeneratorComponent,

    DialogDetailedLogsWallpaperComponent,
    LmListsComponent

  ],
  imports: [
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    DateTimePickerModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    A11yModule,
    ClipboardModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    FileUploadModule,
    TreeviewModule.forRoot(),
    MatFormFieldModule,
    MatPaginatorModule,
    NgbModule,
    ChartsModule,
    CommonModule
  ],
  exports: [],
  providers: [, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptorService,
    multi: true
  }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}
